import { ChakraFlex, SkeletonLoader } from '@equip.health/ui';

const CareTeamSkeleton = ({ isLoading }: { isLoading: boolean }) => {
  const TOP_LEVEL_ID = 'care-team-skeleton';
  return (
    <ChakraFlex
      data-testid={TOP_LEVEL_ID}
      direction="column"
      gap="12px"
      id={TOP_LEVEL_ID}
    >
      <SkeletonLoader
        height="77px"
        id={`${TOP_LEVEL_ID}__skeleton-loader`}
        isLoaded={!isLoading}
      />
      <SkeletonLoader
        height="77px"
        id={`${TOP_LEVEL_ID}__skeleton-loader`}
        isLoaded={!isLoading}
      />
      <SkeletonLoader
        height="77px"
        id={`${TOP_LEVEL_ID}__skeleton-loader`}
        isLoaded={!isLoading}
      />
      <SkeletonLoader
        height="77px"
        id={`${TOP_LEVEL_ID}__skeleton-loader`}
        isLoaded={!isLoading}
      />
    </ChakraFlex>
  );
};

export default CareTeamSkeleton;
